<button class="flex flex-row items-center align-middle gap-4 w-full p-2 hover:cursor-auto">
    <div>
        <svg class="w-5 h-5 fill-none stroke-slate-100 filter-icon-almost-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="svgIcon" />
        </svg>
    </div>
    <div class="flex flex-row gap-1 items-center align-middle">
        <div class="grow w-[12ch] text-left align-middle">
            Proxy Count
        </div>
        <div (click)="onDecrement()" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center">
            –
        </div>
        <div class="p-1 hover:bg-gray-200 hover:bg-opacity-10">
            <input (change)="onChange($event)" class="bg-transparent w-[4ch] text-center" type="text" value="{{ getCount() }}" size="4" maxlength="4">
        </div>
        <div (click)="onIncrement()" class="w-6 h-6 cursor-pointer hover:bg-gray-200 hover:bg-opacity-10 flex justify-center">
            +
        </div>
    </div>
</button>